import {
  Button,
  Card,
  CardLevel,
  Drawer,
  FormGroup,
  ISelectOption,
  Input,
  PaddingLevel,
  Select,
} from '@pinpointhq/thumbtack';
import * as React from 'react';
import { Company } from '../../../../javascript/models';
import { createToast } from '../../../FlashToaster';
import { DrawerHeader } from '../../../shared/DrawerHeader';

export function EditForm({
  company,
  companySectorOptions,
  fetchData,
  handleClose,
}: {
  company: Company;
  companySectorOptions: ISelectOption[];
  fetchData(): void;
  handleClose(): void;
}) {
  const [companyName, setCompanyName] = React.useState<string>(company.name);
  const [registeredCompanyNumber, setRegisteredCompanyNumber] = React.useState<string>(company.registeredCompanyNumber);
  const [uniqueDivisionIdentifier, setUniqueDivisionIdentifier] = React.useState<string>(
    company.uniqueDivisionIdentifier,
  );
  const [selectedMembership, setSelectedMembership] = React.useState<string>(company.membershipStatus);
  const [selectedCompanySector, setSelectedCompanySector] = React.useState<string>(company.workstream);

  const handleNameChange = (event) => {
    setCompanyName(event.target.value);
  };

  const handleRegisteredCompanyNumberChange = (event) => {
    setRegisteredCompanyNumber(event.target.value);
  };

  const handleUniqueIdentifierDivisionChange = (event) => {
    setUniqueDivisionIdentifier(event.target.value);
  };

  const handleMemberSelect = (selectedItem: ISelectOption) => {
    setSelectedMembership(selectedItem.value);
  };

  const handleSelectorChange = (selectedItem: ISelectOption) => {
    setSelectedCompanySector(selectedItem.value);
  };

  const memebershipOptions = [
    { value: 'none', label: 'None' },
    { value: 'community', label: 'Community' },
    { value: 'premier', label: 'Premier' },
  ];

  const handleSave = () => {
    company.name = companyName;
    company.registeredCompanyNumber = registeredCompanyNumber;
    company.uniqueDivisionIdentifier = uniqueDivisionIdentifier;
    company.membershipStatus = selectedMembership;
    company.workstream = selectedCompanySector;
    company.save().then((success) => {
      if (success) {
        createToast({ type: 'success', text: 'Company successfully saved' });
        handleClose();
        fetchData();
      } else {
        createToast({ type: 'error', text: 'Unable to save company' });
      }
    });
  };

  const selectedMembershipOption = memebershipOptions.find((option) => option.value === selectedMembership);
  const selectedCompanySectorOption = companySectorOptions.find((option) => option.value === selectedCompanySector);

  return (
    <Drawer isOpen={true} onClose={handleClose} maxWidth={600}>
      <DrawerHeader title="Edit Organisation" handleClose={handleClose} />
      <div style={{ overflowY: 'scroll' }}>
        <Card
          paddingLevel={PaddingLevel.REGULAR}
          level={CardLevel.NONE}
          cardInnerProps={{ className: 'pad-h-5 pad-v-3' }}
        >
          <FormGroup label="Name">
            <Input type="text" value={companyName} onChange={handleNameChange} />
          </FormGroup>
          <FormGroup label="Registered company number">
            <Input type="text" value={registeredCompanyNumber} onChange={handleRegisteredCompanyNumberChange} />
          </FormGroup>
          <FormGroup label="Unique division identifier">
            <Input type="text" value={uniqueDivisionIdentifier} onChange={handleUniqueIdentifierDivisionChange} />
          </FormGroup>
          <FormGroup label="Membership type">
            <Select
              fill={true}
              buttonProps={{ large: true }}
              items={memebershipOptions}
              onItemSelect={handleMemberSelect}
              activeItem={selectedMembershipOption}
            />
          </FormGroup>
          <FormGroup label="Company sector">
            <Select
              fill={true}
              buttonProps={{ large: true }}
              items={companySectorOptions}
              onItemSelect={handleSelectorChange}
              activeItem={selectedCompanySectorOption}
            />
          </FormGroup>
          <Button text="Save" onClick={handleSave} large={true} />
        </Card>
      </div>
    </Drawer>
  );
}
